import './styles.scss'
import React from 'react'
import ReactDOM from 'react-dom/client'
import Card from './components/Card'
import CardHover from './components/CardHover'
import Deck from './components/Deck'
import Debug from './components/Debug'
import { Provider } from 'react-redux'
import { debugEnabled } from './util'
import { faSignIn, faSpinner, faUser } from '@fortawesome/free-solid-svg-icons'
import { library } from '@fortawesome/fontawesome-svg-core'
import { store } from './store/store'
import { v4 } from 'uuid'



library.add(faSignIn, faSpinner, faUser)

const options = (elem) => {
  return {
    onlyBack: elem.parentNode.classList.contains('only-back'),
    onlyFront: elem.parentNode.classList.contains('only-front'),
    reverse: elem.parentNode.classList.contains('reverse'),
    sideBySide: elem.parentNode.classList.contains('side-by-side'),
    rotate: elem.parentNode.classList.contains('rotate'),
  }
}

// debug
if (debugEnabled()) {
  const elem = document.getElementsByClassName('debug-messages')[0]
  if (elem) {
    ReactDOM.createRoot(elem).render(
      <Provider store={store}>
        <Debug />
      </Provider>
    )
  }
}

const MakeCards = (elemArray, subClassName, tag) => {
  [...elemArray].forEach((parentElem) => {
    ReactDOM.createRoot(parentElem).render(
      <Provider store={store}>
        {[...parentElem.children]
          .filter((elem) => elem.className === subClassName)
          .map((elem) => (
            <Card
              key={v4()}
              name={elem.getAttribute('name').replace('★', 'star').replace('†', 'dagger').replace('Φ', 'phi')}
              tag={tag}
              {...options(elem)}
            />
          ))}
      </Provider>
    )
  })
}

const MakeLinks = (elemArray, subClassName, tag) => {
  [...elemArray].forEach((parentElem) => {
    ReactDOM.createRoot(parentElem).render(
      <Provider store={store}>
        {[...parentElem.children]
          .filter((elem) => elem.className === subClassName)
          .map((elem) => (
            <CardHover
              key={v4()}
              name={elem.getAttribute('content').replace('★', 'star').replace('†', 'dagger').replace('Φ', 'phi')}
              tag={tag}
              {...options(elem)}
            >
              {elem.textContent}
            </CardHover>
          ))}
      </Provider>
    )
  })
}

// ----------------------------------------------------------------MAGIC-----------------------------------------------------//

// [ec]
const magicCardElems = document.getElementsByClassName('edhrecp__cards')
MakeCards(magicCardElems, 'edhrecp__card-container', 'ec')

// [ed]
const magicDeckElems = document.getElementsByClassName('edhrecp__deck')
;[...magicDeckElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
      .filter((elem) => elem.className === 'edhrecp__deck-s')
      .map((elem) => {
        return <Deck key={v4()} value={elem.getAttribute('cards')} title={elem.getAttribute('name')} site={elem.getAttribute('site')} tag='eDeckPreview'/>
      })}
    </Provider>
  )
})

// [el]
const magicLinkElems = document.getElementsByClassName('edhrecp__link')
MakeLinks(magicLinkElems, 'edhrecp__link-a', 'el')
//------------------------------------------------------------------------MAGIC------------------------------------------------------------------//

//-----------------------------------------------------------------------FAB-------------------------------------------------------------------//
// [fc]
const fabCardElems = document.getElementsByClassName('fabp__cards')
MakeCards(fabCardElems, 'fabp__card-container', 'fc')


// [fd]
const fabDeckElems = document.getElementsByClassName('fabp__deck')
;[...fabDeckElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
      .filter((elem) => elem.className === 'fabp__deck-s')
      .map((elem) => {
        return <Deck key={v4()} value={elem.getAttribute('cards')} title={elem.getAttribute('name')} site={elem.getAttribute('site')} tag='fDeckPreview'/>
      })}
    </Provider>
  )
})

// [fl]
const fabLinkElems = document.getElementsByClassName('fabp__link')
MakeLinks(fabLinkElems, 'fabp__link-a', 'fl')

// --------------------------------------------------------------------FAB------------------------------------------------------------------------ //

//-----------------------------------------------------------------------POKEMON-------------------------------------------------------------------//
// [pc]
const pokeCardElems = document.getElementsByClassName('pokep__cards')
MakeCards(pokeCardElems, 'pokep__card-container', 'pc')


// [pd]
const pokeDeckElems = document.getElementsByClassName('pokep__deck')
;[...pokeDeckElems].forEach((parentElem) => {
  ReactDOM.createRoot(parentElem).render(
    <Provider store={store}>
      {[...parentElem.children]
      .filter((elem) => elem.className === 'pokep__deck-s')
      .map((elem) => {
        return <Deck key={v4()} value={elem.getAttribute('cards')} title={elem.getAttribute('name')} site={elem.getAttribute('site')} tag='pDeckPreview'/>
      })}
    </Provider>
  )
})

// [pl]
const pokeLinkElems = document.getElementsByClassName('pokep__link')
MakeLinks(pokeLinkElems, 'pokep__link-a', 'pl')

// --------------------------------------------------------------------POKEMON------------------------------------------------------------------------ //
